import { Leaf } from 'lucide-react';

const TREE_LEAVES = [
  { left: '18%', top: '30%', delay: '0s', duration: '6s', size: 14, color: 'text-lime-500' },
  { left: '55%', top: '22%', delay: '1.8s', duration: '7s', size: 12, color: 'text-green-600' },
  { left: '75%', top: '38%', delay: '3.2s', duration: '6.5s', size: 15, color: 'text-lime-600' },
  { left: '35%', top: '45%', delay: '4.5s', duration: '5.5s', size: 11, color: 'text-green-500' },
  { left: '65%', top: '50%', delay: '2.6s', duration: '6s', size: 13, color: 'text-lime-500' },
];

export const HeroTree = () => (
  <div
    aria-hidden="true"
    data-testid="hero-tree"
    className="hidden min-[1800px]:block absolute bottom-3 left-[-30px] min-[1900px]:left-[-20px] h-[360px] min-[1900px]:h-[420px] pointer-events-none z-[6]"
  >
    <img src="/images/hero-tree.png" alt="" className="h-full w-auto select-none" draggable="false" />
    {TREE_LEAVES.map((l) => (
      <Leaf
        key={l.left}
        className={`tree-leaf ${l.color} fill-current`}
        style={{ left: l.left, top: l.top, width: l.size, height: l.size, animationDelay: l.delay, animationDuration: l.duration }}
      />
    ))}
  </div>
);
